/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 傷病者との関係
 */
export type BaseInfoRelatedPersonRelationshipEnum =
  (typeof BaseInfoRelatedPersonRelationshipEnum)[keyof typeof BaseInfoRelatedPersonRelationshipEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoRelatedPersonRelationshipEnum = {
  FAMILY: 'FAMILY',
  RELATED: 'RELATED',
  DOCTOR: 'DOCTOR',
  POLICEMAN: 'POLICEMAN',
} as const;
